import {computed, override} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {FullGameDataSource} from "../../../domain/full-game/models/full-game-data-source";
import {TopPerformersCategoryViewModel} from "../../../domain/full-game/models/top-performers/category/top-performers.category.view-model";
import {TopPerformersCategoryDomainModel} from "../../../domain/full-game/models/top-performers/category/top-performers.category.domain-model";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {TopPerformersWidgetConfig} from "../top-performers-widget.config";
import {ODDS_TYPES} from "../../../core/components/odds/components/odds-consts";
import {ROUTE_NAMES} from "../../../core/consts";

export class TopPerformersWidgetState extends BaseModuleState {
  dataSource: FullGameDataSource;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, TopPerformersWidgetConfig];


  @computed get categories(): Array<TopPerformersCategoryViewModel> {
    const categories: Array<TopPerformersCategoryViewModel> = this.dataSource?.game.topPerformers.categories?.map((category: TopPerformersCategoryDomainModel) => new TopPerformersCategoryViewModel(category, this.oddsType));

    return categories;
  }

  @override get isPopulated(): Boolean {
    const hasPlayersFromBothTeams = this.dataSource?.game?.topPerformers?.categories.find(item => item.homePlayer && item.awayPlayer);

    return hasPlayersFromBothTeams;
  }

  @computed get isScheduled(): Boolean {
    return this.dataSource?.game.isScheduled
  }

  @computed get title(): String{
    const title: String = this.isScheduled ? this.terms.WEB_SEASON_LEADERS : this.terms.WEB_GAME_LEADERS;

    return title;
  }

  @computed get oddsType(): ODDS_TYPES {
    return this.appState.currentOddsType;
  }

  @computed get isGameRoute() {
    return this.currentLinkModel.name === ROUTE_NAMES.game
  }
}
